import React from "react";
import { Check } from "lucide-react";

const FLOW = [
  { key: "pending", label: "Pending" },
  { key: "accepted", label: "Accepted" },
  { key: "baking", label: "In the kitchen" },
  { key: "ready", label: "Ready" },
  { key: "completed", label: "Completed" },
];

export function StatusTimeline({ status }) {
  if (status === "rejected") {
    return (
      <div className="rounded-xl p-4 text-sm font-semibold" style={{ background: "#fdecec", color: "#b91c1c" }}>
        This order was declined.
      </div>
    );
  }
  const activeIdx = FLOW.findIndex((s) => s.key === status);
  return (
    <div className="space-y-0" data-testid="status-timeline">
      {FLOW.map((step, i) => {
        const done = i < activeIdx;
        const current = i === activeIdx;
        const reached = i <= activeIdx;
        return (
          <div key={step.key} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div
                className="h-8 w-8 rounded-full flex items-center justify-center text-xs font-bold transition"
                style={{
                  background: reached ? "var(--brand)" : "var(--surface-2)",
                  color: reached ? "var(--brand-fg)" : "var(--muted)",
                  boxShadow: current ? "0 0 0 4px var(--accent-soft)" : "none",
                }}
              >
                {done ? <Check size={16} /> : i + 1}
              </div>
              {i < FLOW.length - 1 && (
                <div className="w-0.5 h-8" style={{ background: i < activeIdx ? "var(--brand)" : "var(--border)" }} />
              )}
            </div>
            <div className="pt-1 pb-4">
              <div
                className="font-semibold"
                style={{ color: reached ? "var(--ink)" : "var(--muted)" }}
              >
                {step.label}
              </div>
              {current && (
                <div className="text-xs" style={{ color: "var(--brand)" }}>
                  Current status
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export const STATUS_META = {
  pending: { label: "Pending", bg: "#fef4d6", color: "#8a6100" },
  accepted: { label: "Accepted", bg: "#e0edff", color: "#1e40af" },
  baking: { label: "In kitchen", bg: "#fdeccb", color: "#92600a" },
  ready: { label: "Ready", bg: "#d9f6e4", color: "#12633a" },
  completed: { label: "Completed", bg: "#eceef2", color: "#475569" },
  rejected: { label: "Rejected", bg: "#fdecec", color: "#b91c1c" },
};

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || STATUS_META.pending;
  return (
    <span
      className="px-2.5 py-1 rounded-full text-xs font-bold uppercase tracking-wide"
      style={{ background: m.bg, color: m.color }}
      data-testid={`status-badge-${status}`}
    >
      {m.label}
    </span>
  );
}
